export default "__VITE_ASSET__CX$zj4s4__"